
import i18next from 'i18next';
import I18nextXHRBackend from 'i18next-xhr-backend';

import TRANSLATION_LANGUAGES_RESOURCES from '../../../../lang/countries-enGB.json';
import LANGUAGES_RESOURCES from '../../../../lang/languages.json';
import MAIN_RESOURCES from '../../../../lang/main.json';

import languageDetector from './languageDetector';

/**
 * The available/supported languages.
 *
 * XXX The element at index zero is the default language.
 *
 * @public
 * @type {Array<string>}
 */
export const LANGUAGES: Array<string> = Object.keys(LANGUAGES_RESOURCES);

/**
 * The default language.
 *
 * XXX The element at index zero of {@link LANGUAGES} is the default language.
 *
 * @public
 * @type {string} The default language.
 */
export const DEFAULT_LANGUAGE = 'en';

/**
 * The available/supported translation languages.
 *
 * @public
 * @type {Array<string>}
 */
export const TRANSLATION_LANGUAGES = Object.keys(TRANSLATION_LANGUAGES_RESOURCES);

/**
 * The available/supported translation languages head. (Languages displayed on the top ).
 *
 * @public
 * @type {Array<string>}
 */
export const TRANSLATION_LANGUAGES_HEAD = [ DEFAULT_LANGUAGE ];

/**
 * The options to initialize i18next with.
 *
 * @type {Object}
 */
const options = {
    backend: {
        loadPath: 'lang/{{ns}}-{{lng}}.json'
    },
    defaultNS: 'main',
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    load: 'languageOnly',
    ns: [ 'main', 'languages' ],
    react: {
        useSuspense: false
    },
    returnEmptyString: false,
    returnNull: false,

    // XXX i18next modifies the array lngWhitelist so make sure to clone
    // LANGUAGES.
    whitelist: LANGUAGES.slice()
};

// On React Native there is no XHR backend (translations are bundled into the
// app), so the backend is only registered on Web. i18next >= 23 rejects
// `.use({})` with "You are passing a wrong module! Please check the object you
// are passing to i18next.use()", so we must not pass an empty object placeholder
// as was previously done for React Native.
if (navigator.product !== 'ReactNative') {
    i18next.use(I18nextXHRBackend);
}

i18next
    .use(languageDetector)
    .init(options);

// Add default language which is preloaded from the source code.
// i18next.addResourceBundle(
//     DEFAULT_LANGUAGE,
//     'countriesm',
//     COUNTRIES_RESOURCES,
//     /* deep */ true,
//     /* overwrite */ true);
i18next.addResourceBundle(
    DEFAULT_LANGUAGE,
    'languages',
    LANGUAGES_RESOURCES,
    /* deep */ true,
    /* overwrite */ true);
i18next.addResourceBundle(
    DEFAULT_LANGUAGE,
    'main',
    MAIN_RESOURCES,
    /* deep */ true,
    /* overwrite */ true);

// Add builtin languages.
// XXX: Note we are using require here, because we want the side-effects of the
// import, but imports can only be placed at the top, and it would be too early,
// since i18next is not yet initialized at that point.
require('./BuiltinLanguages');

export default i18next;
